import qs from 'qs';
import { AxiosInstance } from 'axios';
import { OffsetPaginationInput } from '@app/data/inputs';
import { CollectionResource } from '@app/data/resources';
import { AiTaskBriefFilterInput, GenerateAiTaskBriefInput } from './inputs';
import { AiTaskBriefRef } from './refs';
import { AiTaskBriefResource } from './resources';

export default class AiTaskBrief {
    private basePath = '/api/ai-task-brief';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Generate new AI task brief
    generate = async (input: GenerateAiTaskBriefInput): Promise<AiTaskBriefRef> => {
        // Get current timeout
        const defaultTimeout = this.http.defaults.timeout;

        // Update timeout
        this.http.defaults.timeout = 60000;

        const { data } = await this.http.post(`${this.basePath}/generate`, input);

        // Return old timeout value back
        this.http.defaults.timeout = defaultTimeout;

        return data;
    };

    // Get list of AI generated briefs
    getAiTaskBriefList = async (
        pagination: OffsetPaginationInput,
        filter?: AiTaskBriefFilterInput
    ): Promise<CollectionResource<AiTaskBriefResource, {}>> => {
        const query = qs.stringify({ ...pagination, ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Get single AI brief generation info
    getById = async (id: ID): Promise<AiTaskBriefResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);
        return data;
    };
}
